/* =====================================================================
   DANSKO QUICK SHOP DRAWER (dansko.com style)
   Opened by any [data-dk-quick-shop="<handle>"] button (product cards).
   - Loads /products/<handle>.js
   - Colour row = sibling products named "Dansko <Style>-<Colour>"
     (found with Shopify predictive search, same as the Globo colour groups)
   - Size grid with EU / US toggle, other options (e.g. Width) as pills
   - Adds to cart with /cart/add.js and refreshes Dawn's cart drawer, so
     Shopify customer events / pixels still record the add to cart.
   ===================================================================== */
(function () {
  'use strict';

  var cfg = window.dkQuickShop || {};
  var root = (cfg.rootUrl || '/').replace(/\/$/, '');

  /* Dansko EU to US conversion (women's 35-43, men's 44+) */
  var US_SIZES = {
    35: '4.5-5', 36: '5.5-6', 37: '6.5-7', 38: '7.5-8', 39: '8.5-9', 40: '9.5-10',
    41: '10.5-11', 42: '11.5-12', 43: '12.5-13',
    44: 'M 11.5-12', 45: 'M 12.5-13', 46: 'M 13.5-14', 47: 'M 14.5-15'
  };

  var state = { product: null, selected: [], unit: 'EU', lastFocus: null, siblingsFor: null };
  var drawer, panel, body, overlay;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var value = (cents || 0) / 100;
    function withDelims(n, decimals, thousands, dec) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? dec : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  function img(url, width) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function splitTitle(title) {
    var i = title.indexOf('-');
    var name = (i > -1 ? title.slice(0, i) : title).replace(/^Dansko\s+/i, '').trim();
    var colour = i > -1 ? title.slice(i + 1).trim() : '';
    return { name: name, colour: colour, stylePrefix: i > -1 ? title.slice(0, i + 1).toLowerCase() : null };
  }

  function isSizeOption(name) { return /size/i.test(name); }
  function isColourOption(name) { return /colou?r/i.test(name); }

  function sizeLabel(value) {
    if (state.unit !== 'US') return String(value).replace(/\s*eu$/i, '');
    var m = String(value).match(/^(\d{2})(\s*eu)?$/i);
    return m && US_SIZES[m[1]] ? US_SIZES[m[1]] : value;
  }

  /* EU / US choice is shared with the product page size picker (dansko-us.js) */
  function readUnit() {
    try { return localStorage.getItem('dkSizeUnit') === 'US' ? 'US' : 'EU'; } catch (e) { return 'EU'; }
  }
  function saveUnit(unit) {
    try { localStorage.setItem('dkSizeUnit', unit); } catch (e) { /* storage blocked */ }
  }

  /* ---------- drawer shell ---------- */
  function build() {
    if (drawer) return;
    drawer = document.createElement('div');
    drawer.className = 'dk-qs';
    drawer.setAttribute('hidden', '');
    drawer.innerHTML =
      '<div class="dk-qs__overlay" data-dk-qs-close></div>' +
      '<div class="dk-qs__panel" role="dialog" aria-modal="true" aria-label="Quick shop" tabindex="-1">' +
        '<button type="button" class="dk-qs__close" aria-label="Close" data-dk-qs-close>' +
          '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.4" fill="none"/></svg>' +
        '</button>' +
        '<div class="dk-qs__body"></div>' +
      '</div>';
    document.body.appendChild(drawer);
    panel = drawer.querySelector('.dk-qs__panel');
    body = drawer.querySelector('.dk-qs__body');
    overlay = drawer.querySelector('.dk-qs__overlay');

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-dk-qs-close]')) { close(); return; }
      var opt = e.target.closest('[data-dk-opt]');
      if (opt && !opt.disabled) {
        state.selected[Number(opt.dataset.dkOpt)] = opt.dataset.value;
        render();
        return;
      }
      var sib = e.target.closest('[data-dk-sibling]');
      if (sib) {
        e.preventDefault();
        if (sib.dataset.dkSibling !== state.product.handle) load(sib.dataset.dkSibling, true);
        return;
      }
      if (e.target.closest('[data-dk-unit]')) {
        state.unit = state.unit === 'EU' ? 'US' : 'EU';
        saveUnit(state.unit);
        render();
        return;
      }
      var dot = e.target.closest('[data-dk-slide]');
      if (dot) {
        var track = drawer.querySelector('.dk-qs__track');
        track.scrollTo({ left: track.clientWidth * Number(dot.dataset.dkSlide), behavior: 'smooth' });
        return;
      }
      if (e.target.closest('[data-dk-add]')) addToCart();
    });

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') trapFocus(e);
    });
  }

  function trapFocus(e) {
    var f = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(handle, opener) {
    build();
    state.lastFocus = opener || document.activeElement;
    state.unit = readUnit();
    body.innerHTML = '<div class="dk-qs__loading" aria-live="polite"><span class="dk-qs__spinner"></span></div>';
    drawer.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden', 'dk-qs-open');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); panel.focus(); });
    load(handle, false);
  }

  function close() {
    if (!drawer || drawer.hasAttribute('hidden')) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden', 'dk-qs-open');
    setTimeout(function () { drawer.setAttribute('hidden', ''); }, 300);
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
  }

  function load(handle, keepSiblings) {
    return fetch(root + '/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        state.product = p;
        var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        state.selected = first ? first.options.slice() : [];
        if (!keepSiblings) state.siblings = null;
        render();
        if (!keepSiblings) loadSiblings(p);
      })
      .catch(function () {
        body.innerHTML = '<p class="dk-qs__error">Sorry, this product could not be loaded. <a href="' + root + '/products/' + esc(handle) + '">View product</a></p>';
      });
  }

  /* Colour siblings: other products titled "Dansko <Style>-<Colour>" */
  function loadSiblings(p) {
    if (!window.DanskoSwatches || p.title.indexOf('-') < 0) return;
    window.DanskoSwatches.get(p.title).then(function (found) {
      var list = found.map(function (x) { return { handle: x.handle, title: x.title, image: x.thumb || x.image }; });
      if (!list.some(function (x) { return x.handle === p.handle; })) {
        list.unshift({ handle: p.handle, title: p.title, image: p.featured_image });
      } else {
        list.sort(function (a, b) { return a.handle === p.handle ? -1 : b.handle === p.handle ? 1 : 0; });
      }
      state.siblings = list;
      if (state.product) render();
    });
  }

  /* ---------- rendering ---------- */
  function currentVariant() {
    var p = state.product;
    return p.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === state.selected[i]; });
    });
  }

  function valueAvailable(optIndex, value) {
    return state.product.variants.some(function (v) {
      if (!v.available || v.options[optIndex] !== value) return false;
      return v.options.every(function (o, i) { return i === optIndex || i > optIndex || o === state.selected[i]; });
    });
  }

  function render() {
    var p = state.product;
    if (!p) return;
    var t = splitTitle(p.title);
    var v = currentVariant();
    var price = v ? v.price : p.price;
    var compare = v ? v.compare_at_price : p.compare_at_price;
    var images = (p.media && p.media.length ? p.media.filter(function (m) { return m.media_type === 'image'; }).map(function (m) { return m.src; }) : p.images) || [];
    if (!images.length && p.featured_image) images = [p.featured_image];

    var html = '';
    html += '<div class="dk-qs__head"><a class="dk-qs__name" href="' + esc(p.url) + '">' + esc(t.name) + '</a>' +
      '<span class="dk-qs__price">' + (compare && compare > price ? '<span class="dk-qs__sale">' + money(price) + '</span> <s>' + money(compare) + '</s>' : money(price)) + '</span></div>';

    html += '<div class="dk-qs__gallery"><div class="dk-qs__track">' + images.map(function (src, i) {
      return '<div class="dk-qs__slide"><img src="' + esc(img(src, 700)) + '" alt="' + esc(p.title) + (i ? ' image ' + (i + 1) : '') + '" loading="' + (i ? 'lazy' : 'eager') + '"></div>';
    }).join('') + '</div>' +
      (images.length > 1 ? '<div class="dk-qs__dots">' + images.map(function (s, i) {
        return '<button type="button" class="dk-qs__dot' + (i === 0 ? ' is-active' : '') + '" data-dk-slide="' + i + '" aria-label="View slide ' + (i + 1) + '"></button>';
      }).join('') + '</div>' : '') + '</div>';

    if (t.colour || state.siblings) {
      html += '<div class="dk-qs__group"><div class="dk-qs__label">Color <strong>' + esc(t.colour || p.title) + '</strong></div>';
      if (state.siblings && state.siblings.length > 1) {
        html += '<div class="dk-qs__swatches">' + state.siblings.map(function (s) {
          var active = s.handle === p.handle;
          return '<a class="dk-qs__swatch' + (active ? ' is-active' : '') + '" href="' + root + '/products/' + esc(s.handle) + '" data-dk-sibling="' + esc(s.handle) + '" title="' + esc(splitTitle(s.title).colour) + '"' + (active ? ' aria-current="true"' : '') + '>' +
            (s.image ? '<img src="' + esc(img(s.image, 120)) + '" alt="' + esc(splitTitle(s.title).colour) + '" loading="lazy">' : '<span>' + esc(splitTitle(s.title).colour) + '</span>') + '</a>';
        }).join('') + '</div>';
      }
      html += '</div>';
    }

    p.options.forEach(function (opt, i) {
      var name = opt.name || opt;
      var values = opt.values || [];
      if (isColourOption(name) || (values.length === 1 && /default title/i.test(values[0]))) return;
      var sizey = isSizeOption(name);
      var euSizes = sizey && values.every(function (x) { return /^\d{2}(\s*eu)?$/i.test(String(x)); });
      html += '<div class="dk-qs__group">';
      if (sizey) {
        html += '<div class="dk-qs__label dk-qs__label--size"><span>Select ' + esc(name) + '</span>' +
          (euSizes ? '<span class="dk-qs__unit">EU</span><button type="button" class="dk-qs__switch' + (state.unit === 'US' ? ' is-on' : '') + '" role="switch" aria-checked="' + (state.unit === 'US') + '" aria-label="Switch between EU and US sizing" data-dk-unit><span></span></button><span class="dk-qs__unit">US</span>' : '') +
          '</div><div class="dk-qs__sizes">';
      } else {
        html += '<div class="dk-qs__label">' + esc(name) + '</div><div class="dk-qs__pills">';
      }
      values.forEach(function (val) {
        var ok = valueAvailable(i, val);
        var sel = state.selected[i] === val;
        html += '<button type="button" class="dk-qs__opt' + (sel ? ' is-selected' : '') + (ok ? '' : ' is-unavailable') + '" data-dk-opt="' + i + '" data-value="' + esc(val) + '" aria-pressed="' + sel + '">' +
          esc(sizey && euSizes ? sizeLabel(val) : val) + '</button>';
      });
      html += '</div></div>';
    });

    var canBuy = v && v.available;
    html += '<div class="dk-qs__actions">' +
      '<button type="button" class="dk-qs__add" data-dk-add' + (canBuy ? '' : ' disabled') + '>' + (canBuy ? ((window.variantStrings && window.variantStrings.addToCart) || 'Add to cart') : (v ? (cfg.soldOut || 'Sold out') : 'Unavailable')) + '</button>' +
      '<p class="dk-qs__msg" role="alert" hidden></p>' +
      '<a class="dk-qs__details" href="' + esc(p.url + (v ? '?variant=' + v.id : '')) + '">View Full Details</a>' +
      '</div>';

    body.innerHTML = html;

    var track = body.querySelector('.dk-qs__track');
    if (track) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        body.querySelectorAll('.dk-qs__dot').forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }, { passive: true });
    }
  }

  /* ---------- add to cart ---------- */
  function addToCart() {
    var v = currentVariant();
    if (!v || !v.available) return;
    var btn = body.querySelector('[data-dk-add]');
    var msg = body.querySelector('.dk-qs__msg');
    btn.disabled = true;
    btn.classList.add('is-loading');
    var cartDrawer = document.querySelector('cart-drawer');
    var cartNotification = document.querySelector('cart-notification');
    var target = cartDrawer || cartNotification;
    var payload = { id: v.id, quantity: 1 };
    if (target && target.getSectionsToRender) {
      payload.sections = target.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : root + '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          msg.textContent = res.data.description || res.data.message || 'Could not add to cart.';
          msg.hidden = false;
          btn.disabled = false;
          btn.classList.remove('is-loading');
          return;
        }
        var state2 = res.data;
        if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dansko-quick-shop', productVariantId: v.id, cartData: state2 });
        }
        close();
        if (target && target.renderContents && state2.sections) {
          target.renderContents(state2);
          if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        } else {
          window.location = cfg.cartUrl || root + '/cart';
        }
      })
      .catch(function () {
        msg.textContent = 'Could not add to cart. Please try again.';
        msg.hidden = false;
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }

  /* ---------- wire up card buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-dk-quick-shop]');
    if (!b || b.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    open(b.getAttribute('data-dk-quick-shop'), b);
  }, true);

  window.DanskoQuickShop = { open: open, close: close };
})();
